import React from "react";
import useWindowDimensions from "../../utils/Responsive";
import "./services.scss";

export const ServicesSection = (props) => {
  const { title, description, image, type, backgroundColor } = props;
  const { width } = useWindowDimensions();
 

  return (
    <div className="service-container" style={{ backgroundColor: backgroundColor}}>
        <div style={{ display: 'flex', flexDirection: width > 800 ? type === "one" ? 'row' : 'row-reverse' : 'column'}}>
        <div className="leftSection">
        <div className="title">{title}</div>
        <div className="description">{description}</div>
        <div style={{ width: "100%", marginTop: "50px" }}></div>
      </div>
      <div className="rightSection">
        <img src={image} alt="services" />
      </div>
        </div>
    </div>
  );
};
